import makeRequest from "./makeRequest";
import getRuntimeConstants from "../runtimeConstants";
import { getAuthorisationHeader } from "../utils/identity";

const getRequestProperties = ({ authorisationHeader }) => {
  const { productSummariesApiUrl } = getRuntimeConstants();

  return {
    url: productSummariesApiUrl,
    headers: {
      authorization: authorisationHeader,
    },
  };
};

export default async function getProductSummaries(products) {
  if (!products) {
    return [];
  }

  const productIds = products?.map((product) => product?.id).join(",");

  if (!productIds) {
    return [];
  }

  const authorisationHeader = await getAuthorisationHeader();

  const {
    webContext: { browseCountry, browseLanguage, keyStoreDataversion, storeId },
  } = getRuntimeConstants();

  const params = {
    store: storeId,
    keyStoreDataversion,
    productIds,
    lang: browseLanguage,
    expand: "variants",
    country: browseCountry,
  };

  return makeRequest({
    params,
    ...getRequestProperties({ authorisationHeader }),
    handleErrorReturnValue: () => [],
  });
}
